import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import ForceChangePasswordPage from './pages/ForceChangePasswordPage';
import ImprintPage from './pages/ImprintPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

// Admin Pages
import AdminLayout from './layouts/AdminLayout';
import DashboardPage from './pages/admin/DashboardPage';
import MediaLibraryPage from './pages/admin/MediaLibraryPage';
import ImageDetailPage from './pages/admin/ImageDetailPage';
import CategoriesPage from './pages/admin/CategoriesPage';
import CmsPage from './pages/admin/CmsPage';
import UsersPage from './pages/admin/UsersPage';
import SettingsPage from './pages/admin/SettingsPage';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/impressum" element={<ImprintPage />} />
          <Route path="/datenschutz" element={<PrivacyPage />} />
          <Route path="/agb" element={<TermsPage />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin/change-password" element={<ForceChangePasswordPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="media" element={<MediaLibraryPage />} />
            <Route path="media/:imageId" element={<ImageDetailPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="cms" element={<CmsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
        
        <Toaster 
          position="bottom-right" 
          richColors 
          toastOptions={{
            duration: 4000,
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
